import React from 'react';
import {observer, PropTypes} from 'mobx-react';

@observer
export class SearchForm extends React.Component {

  static propTypes = {
    store: PropTypes.observableObject.isRequired
  }

  constructor(props) {
    super(props);
    this.store = this.props.store;
  }

  componentDidUpdate(){

    if(this.store.searchQuery.length>0)
    document.getElementById('Search-btn').style.backgroundImage = 'url(\'/images/search-icon-blue.svg\')';
    else
    document.getElementById('Search-btn').style.backgroundImage = 'url(\'/images/search-icon.svg\')';


  }

  handleInput = (event) => {
    this.store.handleInput(event.target.value)
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.store.searchContent();
  }
  handelResetSearch=()=>{
      this.store.resetSearch();
  }
  handleClearClick = () => {
    this.store.clearSearchQuery();
  }
  renderSearchResult(){

    if( this.props.store.resultCount!=0 && this.props.store.resultCount>-1){
      if(this.props.store.resultCount!=1)
      {
        return <p className='search-result'>
            Showing {this.props.store.resultCount} results for “{this.props.store.searchValue}”.
            </p>
      }
      else{
        return <p className='search-result'>
            Showing {this.props.store.resultCount} result for “{this.props.store.searchValue}”.
            </p>
      }
    }
    
    if(this.props.store.resultCount==0 && this.props.store.isSearchClicked){
        return <p className='error-result'>
        No results for “{this.props.store.searchValue}”. Try another search term.
    </p>
    }
    else{
        return null
    }
  }
  render() {
    const clearButtonVisible = this.store.searchQuery.length > 0;
    const resetButtonVisible = this.store.isSearchClicked;
    return (
    <form className="search-input form-group" onSubmit={this.handleSubmit}>
      <label htmlFor="search-box" className="form-group-title">
        <span className="sr-only">Search content</span>Search FirstNet help
      </label>
      { resetButtonVisible && <button className='reset-search' type='button' onClick={this.handelResetSearch}>
      <span className="sr-only"> Reset Search</span>
          Reset search
       </button>}
      <div className="input-group">
        <input
          id="search-box"
          className="form-control"
          type="search" onChange={this.handleInput} value={this.store.searchQuery} placeholder="Search" />
        {clearButtonVisible && <span className="input-group-append">
          <button className="clear-btn" type="button" onClick={this.handleClearClick}>
            <span className="sr-only">Clear</span>
            {/* <span aria-hidden="true" className="icon-close"/> */}
          </button>
        </span>}
        <span className="input-group-append">
          <button className="submit-btn" type="submit" id='Search-btn' disabled={!clearButtonVisible}>
            <span className="sr-only">Search</span>
            {/* <span aria-hidden="true" className="icon-search"/> */}
          </button>
        </span>
      </div>
      {this.renderSearchResult()}
    </form>);
  }
}
